/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.bus = new Vue();

// import * as VueGoogleMaps from 'vue2-google-maps';
// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import VueRangeSlider from 'vue-range-component';
// import 'swiper/css/swiper.css';

// Vue.use(VueAwesomeSwiper);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBbSvw8bGe1rH8n70pMo1pn6IWwhypLMLk',
//     libraries: 'places', // necessary for places input
//   },
// });
// Vue.component('vue-range-slider', VueRangeSlider);


import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// import { BootstrapVue, IconsPlugin, DropdownPlugin } from "bootstrap-vue";
// Vue.use(BootstrapVue);
// Vue.use(IconsPlugin);
// Vue.use(DropdownPlugin);

Vue.component('quizapp', require('./client/components/quiz-app.vue').default);
Vue.component('problem-modal', require('./client/components/problemModal.vue').default);
Vue.component('fb-like-modal', require('./client/components/fb-like-modal.vue').default);
Vue.component('wish-modal', require('./client/components/wish.vue').default);

Vue.component('uni-map', require('./client/uni/uni-map.vue').default);
Vue.component('uni-item-slider', require('./client/uni/uni-item-slider.vue').default);
Vue.component('uni-filter', require('./client/uni/uni-filter.vue').default);

Vue.component(
  'subject-topics-list',
  require('./client/v1/components/subject-topics-list.vue').default
);

Vue.component(
  'university-list',
  require('./client/v1/components/university-list.vue').default
);
Vue.component(
  'uni-faculties',
  require('./client/v1/components/uni-faculties.vue').default
);



Vue.component('quiz-container', require('./client/v1/quiz/quiz-container.vue').default);

Vue.component('question', require('./client/v1/quiz/question.vue').default);
Vue.component('quiz-timer', require('./client/v1/quiz/quiz-timer.vue').default);
Vue.component('quiz-stats', require('./client/v1/quiz/quiz-stats.vue').default);
Vue.component('quiz-actions', require('./client/v1/quiz/quiz-actions.vue').default);

Vue.component('questions-paging', require('./client/v1/quiz/questions-paging.vue').default);
Vue.component('final-result', require('./client/v1/quiz/final-result.vue').default);

import register from './client/components/registration-forms/register.vue';
import quizroom from './client/components/quiz-room.vue';
import addroom from './client/components/add-room.vue';
import chat from './client/components/chat/chat.vue';
import notes from './client/components/notes.vue';
import vote from './client/components/vote.vue';
import comments from './client/comments/container.vue';

import fbquiz from './client/FbQuiz/index.vue';

const app = new Vue({
  components: {
    register,
    quizroom,
    addroom,
    chat,
    notes,
    vote,
    comments,
    fbquiz,
  },
  el: '#app',
  data: {
    unAuth: false,
    showWishModal: false,
    UsersTestId: false,
    showNotes: false,
    disSub: false,

    checking: false,
    answer: '',
    timeline: {},

    registerModal: false,
  },
  methods: {
    showRegisterModal() {
      this.registerModal = true;
    },
    closeRegisterModal() {
      this.registerModal = false;
    },
    answered() {
      this.checking = true;
    },
    closeWishModal() {
      this.showWishModal = false;
    },
    authWishModal() {
      if (!window.App.user) {
        window.bus.$emit('authMsg', {
          msg: 'იმისათვის, რომ შეძლოთ თქვენი აზრის დაფიქსირება გთხოვთ გაიაროთ ავტორიზაცია',
        });
        showRegister();
        return;
      }
      this.showWishModal = true;
    },
    subscribeSubject(slug, $event) {
      if (!window.App.user) return showRegister();
      // if(this.disSub) return alert('გთხოვთ დაელოდოთ სამი წამი')
      this.disSub = true;
      setTimeout(() => (this.disSub = false), 3000);
      $event.currentTarget.classList.toggle('active');
      this.$refs.subP.innerText =
        this.$refs.subP.innerText == 'გამოწერილია' ? 'სიახლეების გამოწერა' : 'გამოწერილია';
      axios.post(`/subject/subscribe/${slug}`);
    },
    // shareQuestion(url, title, desc, image){
    //         FB.ui({
    //           method: 'share_open_graph',
    //           action_type: 'og.shares',
    //           hashtag: "#abiturige",
    //           // quote: 'A Year From Now You Will Wish You Had Started Today',
    //           href: 'https://www.abituri.ge/',
    //           action_properties: JSON.stringify({
    //               object : {
    //                 'og:url': 'https://www.abituri.ge/',
    //                 'og:title': title,
    //                 'og:description': desc,
    //                 'og:og:image:width': '400',
    //                 'og:image:height': '400',
    //                 'og:image': 'https://www.abituri.ge/' + test_img,
    //               }
    //           })
    //        })
    // }
  },
});

require('./client/client.js');
